import type { ReactNode } from 'react'
import { cn } from '../lib/cn.ts'

export type BadgeTone = 'brand' | 'info' | 'warn' | 'neutral' | 'outline'

const TONES: Record<BadgeTone, string> = {
  brand: 'bg-brand-ring text-brand-ink',
  info: 'bg-info-tint text-info-ink',
  warn: 'bg-warn-tint text-warn-ink',
  neutral: 'bg-neutral-tint text-neutral-ink',
  outline: 'border border-line-strong bg-surface-soft text-[#4d483f]',
}

export function Badge({ tone = 'neutral', children, className }: { tone?: BadgeTone; children: ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11.5px] font-semibold tracking-[0.01em]',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
